import * as React from 'react';

// export const IconTwee: React.FC = () => (
// 	<svg
// 		viewBox="0 0 24 24"
// 		width="24"
// 		height="24"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		fill="none"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 	>
// 		<circle cx="8" cy="8" r="1" fill="currentColor" />
// 		<circle cx="16" cy="8" r="1" fill="currentColor" />
// 		<circle cx="8" cy="16" r="1" fill="currentColor" />
// 		<circle cx="16" cy="16" r="1" fill="currentColor" />
// 	</svg>
// );

export const IconFileTwee: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		strokeWidth="2"
		stroke="currentColor"
		fill="none"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M14 3v4a1 1 0 0 0 1 1h4" />
		<path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
		<circle cx="10" cy="12" r="0.5" />
		<circle cx="14" cy="12" r="0.5" />
		<circle cx="10" cy="16" r="0.5" />
		<circle cx="14" cy="16" r="0.5" />
	</svg>
);
